module.exports = __webpack_public_path__ + "static/media/2021-cc.63896291.jpg";